import { TimeEntry, TimeEntryCreate } from '../types/time-entry';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/time-entries';

export const getTimeEntries = async (): Promise<TimeEntry[]> => {
  return await fetcher(`${API_URL}/read`);
};

export const getTimeEntriesByUser = async (userId: string): Promise<TimeEntry[]> => {
  return await fetcher(`${API_URL}/read?user_id=${userId}`);
};

export const getTimeEntriesByDateRange = async (startDate: string, endDate: string): Promise<TimeEntry[]> => {
  return await fetcher(`${API_URL}/read?start_date=${startDate}&end_date=${endDate}`);
};

export const createTimeEntry = async (data: TimeEntryCreate): Promise<TimeEntry> => {
  return await fetcher(`${API_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const updateTimeEntry = async (id: string, data: Partial<TimeEntry>): Promise<TimeEntry> => {
  return await fetcher(`${API_URL}/update/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const deleteTimeEntry = async (id: string): Promise<boolean> => {
  return await fetcher(`${API_URL}/delete/${id}`, {
    method: 'DELETE',
  });
};
